import { render } from "./progress-bar.vue?vue&type=template&id=0c806f10"
import script from "./progress-bar.vue?vue&type=script&lang=js"
export * from "./progress-bar.vue?vue&type=script&lang=js"

import "./progress-bar.vue?vue&type=style&index=0&id=0c806f10&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__